import hamburger from '../../assets/hamburger.svg';
import drawerBackground from '../../assets/manage-drawer-bg.svg';
import { ReactComponent as Cross } from '../../assets/cross.svg';
import { useState } from 'react';
import EZDrawer from 'react-modern-drawer';

// Require styles for EZDrawer
import 'react-modern-drawer/dist/index.css';
import './NavBar.scss';
import { NavBarItem } from './navBarItem';
import { Link, useParams } from 'react-router-dom';
import { useActivityData } from '../manage/UseActivityData';
import { useTranslation } from 'react-i18next';

function NavBarItemElement({
  title,
  isActive = false,
  to,
  state,
}: {
  title: string;
  to: string;
  isActive?: boolean;
  state?: any;
}) {
  const classes = ['pb-0.5', 'text-xl', 'font-bold'];
  classes.push(isActive ? 'text-[#87EFB8]' : 'text-white');

  return (
    <Link
      to={to}
      className="py-5 flex items-center gap-2 border-b border-[rgba(109,255,177,0.4)]"
      state={state}
    >
      {isActive ? (
        <div className="rounded-full border border-solid border-white h-4 aspect-square"></div>
      ) : (
        <></>
      )}
      <span className={classes.join(' ')}>{title}</span>
    </Link>
  );
}

export function NavBar({ title }: { title: NavBarItem }) {
  const [t] = useTranslation(['chatroom', 'common']);
  const { activityInfo, room } = useActivityData();
  const { memberId } = useParams();
  const [isDrawerOpened, setIsDrawerOpened] = useState(false);

  if (!activityInfo || !room) {
    return <></>;
  }

  const toggleDrawer = () => {
    setIsDrawerOpened((prevState) => !prevState);
  };

  const drawerStyle = {
    backgroundImage: `url(${drawerBackground})`,
  };

  const dashboardPath = `/chatrooms/${room.id}`;
  const sharePath = `/chatrooms/${room.id}/share`;
  let memberDetailPath = `${dashboardPath}/members/${activityInfo.members[0].id}`;

  if (memberId) {
    memberDetailPath = `${dashboardPath}/members/${memberId}`;
  }

  return (
    <>
      <nav className="sticky top-0 z-50 bg-manage-primary text-white h-12 flex justify-between items-center px-2.5 py-4 text-xl">
        <span>{t(`${title}`, 'Title')}</span>
        <button onClick={toggleDrawer}>
          <img alt="hamburger" src={hamburger} />
        </button>
      </nav>
      <EZDrawer
        open={isDrawerOpened}
        direction="right"
        size={240}
        onClose={toggleDrawer}
      >
        <div
          className="h-full w-full bg-no-repeat bg-cover p-10"
          style={drawerStyle}
        >
          <NavBarItemElement
            key="list"
            title={t(`${NavBarItem.LIST}`, '回到列表')}
            isActive={NavBarItem.LIST === title}
            to="/chatrooms"
          />
          <NavBarItemElement
            key="dashboard"
            title={t(`${NavBarItem.DASHBOARD}`, '任務總覽')}
            isActive={NavBarItem.DASHBOARD === title}
            to={dashboardPath}
          />
          <NavBarItemElement
            key="member-detail"
            title={t(`${NavBarItem.MEMBER_DETAIL}`, '組員出任務')}
            isActive={NavBarItem.MEMBER_DETAIL === title}
            to={memberDetailPath}
          />
          <NavBarItemElement
            key="share-chatroom"
            title={t(`${NavBarItem.SHARE}`, '分享活動連結')}
            isActive={NavBarItem.SHARE === title}
            to={sharePath}
          />
          <NavBarItemElement
            key="create-activity"
            title={t(`${NavBarItem.CREATE_NEW_ACTIVITY}`, '建立新活動')}
            isActive={NavBarItem.CREATE_NEW_ACTIVITY === title}
            to="/chatrooms/create"
            state={{
              createFrom: room,
              memberCount: activityInfo.members.length,
            }}
          />
          <div
            className="py-5 flex items-center gap-2.5"
            onClick={toggleDrawer}
          >
            <Cross />
            <span className="pb-0.5 text-sm text-white font-light">
              {t('close', '關閉', { ns: 'common' })}
            </span>
          </div>
        </div>
      </EZDrawer>
    </>
  );
}
